import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {ToastType} from '@sportcast/ui-react';
import {v4} from 'uuid';
import {MessageProps} from '../../components/alert/Message';
import {AppDispatch} from '../../store';

export interface MessageState {
    message: MessageProps | undefined;
}

const initialState: MessageState = {
    message: undefined
};

const messageSlice = createSlice({
    name: 'message',
    initialState,
    reducers: {
        messageSet: (state, action: PayloadAction<MessageProps>) => {
            state.message = {
                ...action.payload,
                id: v4()
            };
        }
    }
});

export const {messageSet} = messageSlice.actions;
export default messageSlice.reducer;

export const setMessage = (message?: MessageProps) => (dispatch: AppDispatch) => {
    if (!message) {
        return;
    }
    return dispatch(messageSet(message));
};

export const setSuccessMessage = (text: string) => (dispatch: AppDispatch) => {
    const successMessage: MessageProps = {
        message: text,
        autoClose: true,
        type: ToastType.SUCCESS
    };
    return dispatch(messageSet(successMessage));
};

export const setErrorMessage = (text: string) => (dispatch: AppDispatch) => {
    const errorMessage: MessageProps = {
        message: text,
        autoClose: false,
        type: ToastType.ERROR
    };
    return dispatch(messageSet(errorMessage));
};
